import store from 'store/store'
import { isNotNull } from 'utils/isNotNull'
import { userManager } from 'auth/userManager'
 
export const getAccessToken = () => {
  const oidc = store.getState().oidc || {}
  return (oidc.user || {}).access_token
}
export const hasAccessToken = () => isNotNull(getAccessToken())

export const isUserInLocalStorage = () => {
  const key = `oidc.${userManager._userStoreKey}`
  return Boolean(window.sessionStorage.getItem(key))
}
